import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ProductTypeListPage" */
	'pages/supplier/ProductType/ProductTypeListPage'));

export default [{ component, exact: true, path: '/product_types' }];